import React, { useState, useEffect } from "react";
import { ErrorMessage, useField, Field } from "formik";
import FieldError from "./FieldError";
import * as API from "../api";
import useDebounce from "../components/useDebounce";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import PersonIcon from '@mui/icons-material/Person';
import RoomIcon from '@mui/icons-material/Room';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
const SpecialistSearch = ({ label, ...props }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  let searchSpecialists = async () => {
    setIsSearching(true);
    const response = await API.searchSpecialists(
      debouncedSearchTerm,
      props.patient.member_id,
      props.specialistType,
      props.searchType || "Specialist",
      props.specialistId,
      props.specialistGroupId
    );
    return response;
  };

  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  useEffect(async () => {
    setIsSearching(true);
    const response = await searchSpecialists();
    let sortedResults = response.results.sort((a,b) => { return a.distance_from_patient  - b.distance_from_patient });
    setResults(response.results);
    setIsSearching(false);
    if (props.setSearchedSpecialistPractices) {
      props.setSearchedSpecialistPractices(response.results);
    }
  }, [debouncedSearchTerm]);

  let words = (props.searchType || "Specialist Practice").replace(/([A-Z])/g, " $1");
  let specialistTypeLabel = words.charAt(0).toUpperCase() + words.slice(1);
  let placeholder = `Search for a ${ specialistTypeLabel }`;
  let searchLabel = `Search for a ${ specialistTypeLabel }`;
  return (
    <>
      <label>{searchLabel}</label>
      <div>
        <i>{ props.description || 'You can search name, specialist group, address.'} </i>
      </div>
      <input
        placeholder={placeholder}
        id='specialist-search-field'
        //value={props.value}
        name={'specialist_id'}
        onChange={(el) => {
          setSearchTerm(el.target.value);
        }}
        type="text"
        className="default"
      />
      <div>
        {
          isSearching && (
            <>
              <br />
              <b><i className='fa fa-spinner fa-spin' /> Searching...</b>
            </>
          )
        }
        { !isSearching && results && results.length > 0 && (
          <>
            <div>
              <Box sx={{ width: '100%', border: '1px solid #eee', borderRadius: '3px', bgcolor: 'background.paper' }}>
                <List component="nav" aria-label="main mailbox folders">
                  {
                    results.map((s) => (
                      <ListItemButton key={s.id}
                        onClick={() => {
                          props.setFieldValue(
                            s.id,
                            s
                          );
                          setResults([]);
                        }} component="div">
                        <ListItemText>
                          <PersonIcon /> { s.name }
                          <br/>
                          <small> <LocalHospitalIcon /> { s.specialist_group } </small>
                          <br />
                          <small> <RoomIcon /> { s.address } ({ s.distance_from_patient } miles away) </small>
                        </ListItemText>
                      </ListItemButton>
                    ))
                  }
                </List>
              </Box>

            </div>
            <br />
            <hr />
          </>
        )}
      </div>
    </>
  );
};

export default SpecialistSearch;
